export function enumName(value: string, enumType: any) {
  if (value === undefined || value === null) return null;
  const valueIndex = (Object.values(enumType)).map((val: any) => {
    return val.toString().toUpperCase()
  }).indexOf(value.toString().toUpperCase())

  if (valueIndex > -1) {
    return Object.keys(enumType)[valueIndex]
  }

  return null
}